import React from 'react'
import "./mobilenotification.css"
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import { connect } from "react-redux";
import Notification from '../../Components/NotificationBox/Notification';
import { useHistory } from "react-router-dom";

function MobileNotification({ rootData }) {
    let history = useHistory();
    return (
        <>
            <div className="m-notification block lg:hidden">
                <div className="m-notification--header fixed top-0 bg-white w-full shadow p-2 z-50">
                    <ArrowBackIcon style={{ color: "var(--color-5)" }} onClick={history.goBack}/>
                </div>
                <div className="container-fluid mt-10 mb-20">
                    <div className="row">
                        <div className="col-md-12 col-12">
                            {rootData?.notificationData?.length > 0 ? rootData?.notificationData?.map((notifyData, idx) => {
                                return <Notification key={idx} notifyData={notifyData} />
                            }) : <div className="text-center py-3">
                                <span className="manpro font-semibold text-lg block">Nothing To Show Here</span>
                                <small className="manpro font-medium block">You'll be notified when the notification shows up.</small>
                            </div>}
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

const mapStateToProps = (state) => {
    return state;
};
export default connect(mapStateToProps, null)(MobileNotification)
